import { Component, Input } from '@angular/core';
import { PillColorType } from '@eg/ui';
import { TrainVisitModel } from '@railmybox/api-dispo';
import { comparisonColors } from '../color-pills-consts';

@Component({
  selector: 'rmb-capacity-pill',
  templateUrl: './capacity-pill.component.html',
  styleUrl: './capacity-pill.component.scss',
  standalone: false,
})
export class CapacityPillComponent {
  @Input() train: TrainVisitModel;
  @Input() isAdmin = true;
  @Input() type: 'capacity' | 'weight';
  capacityValueColors: PillColorType = comparisonColors;

  getPillComparisonValue(value1?: number, value2?: number): string {
    const diff = Number(value2) - Number(value1);
    const val2 = Number(value2);

    if (diff === 0) {
      return 'ZERO';
    } else if (diff > val2) {
      return 'GREATER_THAN';
    } else if (diff === val2) {
      return 'EQUAL';
    } else {
      return 'LESS_THAN';
    }
  }
}
